const UrlName = '/task/v1'
export default API => ({
    // 获取目录
    findStudentList({data, params,}) {
        return API({ url: `${UrlName}/taskCertApplyUser/findThirdpartCertUserListByGoods`, params, data ,method: 'POST'});
    }
})
